export default "__VITE_ASSET__zF1ODGFg__"